import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import download from "downloadjs";

import { API_ROOT } from "../../../api/constants";

import * as transactionActions from "..//transaction.actions";
import { getCurrentUser, getCurrentUserTeam } from "../../user/user.selectors";
import { getAllTransactions } from "../transaction.selectors";
import { UserRoles } from "../../user/user.constants";
import { formatDate } from "../../../utils/date-utils";

import Table from "../../common/components/Table";
import { ContentBlock } from "../../pages/components";
import Button from "../../../ui/button/Button";
import RefreshButton from "../../../ui/button/RefreshButton";
import colorThemes from "../../../ui/colorThemes";
import { Localize } from "../../../locale/localization";
import { formatProductDisplayName, sortTableAndHead } from "../../../utils/content-utils";
import colors from "../../../utils/colors";
import TableHeader from "../../common/components/TableHeader";

const StyledHeaderActions = styled.div`
  display: flex;
  align-items: center;

  > * {
    margin-left: 1rem;
  }

  svg {
    fill: ${colors.GRAY_MIDDLE};
    stroke: none;
  }
`;

class LatestTransactionsBlock extends Component {
  state = {
    sortedData: [],
    tableHead: [
      { name: "createdAt", uiName: Localize("transaction.createdAt") },
      { name: "user.lastName", uiName: Localize("sales.person") },
      { name: "timestamp", uiName: Localize("transaction.date") },
      { name: "product.productCategory.name", uiName: Localize("package") },
      { name: "product.type", uiName: Localize("type") }
    ]
  };

  componentWillMount() {
    this.updateSortData(this.props.transactions);
  }

  componentWillReceiveProps(nextProps) {
    this.updateSortData(nextProps.transactions);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : []
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.sortedData);

    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head
      })
    );
  };

  componentWillMount = () => {
    const {
      currentUser,
      getTransactionsForTeam,
      getTransactionsForRegion,
      getTransactionsForChannel
    } = this.props;

    if (currentUser.role === UserRoles.SALESMANAGER) {
      getTransactionsForChannel(currentUser.channel._id);
    } else if (currentUser.role === UserRoles.REGIONMANAGER) {
      getTransactionsForRegion(currentUser.region._id);
    } else {
      getTransactionsForTeam(currentUser.team._id);
    }
  };

  refresh = () => {
    const {
      invalidateTransactionsForTeam,
      invalidateTransactionsForRegion,
      invalidateTransactionsForChannel,
      currentUser
    } = this.props;

    if (currentUser.role === UserRoles.SALESMANAGER) {
      invalidateTransactionsForChannel(currentUser.channel._id);
    } else if (currentUser.role === UserRoles.REGIONMANAGER) {
      invalidateTransactionsForRegion(currentUser.region._id);
    } else {
      invalidateTransactionsForTeam(currentUser.team._id);
    }
  };

  onPrintHistoryClick = () => {
    const token = localStorage.getItem("cmore-sisapiiri-token");
    const url = `${API_ROOT}api/transaction/export`;
    const init = {
      method: "POST",
      headers: new Headers({
        authtoken: `${token}`
      })
    };

    fetch(url, init)
      .then(function(resp) {
        return resp.blob();
      })
      .then(function(blob) {
        download(blob);
      });
  };

  renderHeaderActions = () => {
    return (
      <StyledHeaderActions>
        <Button theme={colorThemes.LIGHT} onClick={this.onPrintHistoryClick}>
          {Localize("action.print.history")}
        </Button>
        <RefreshButton onClick={this.refresh} isLoading={true} />
      </StyledHeaderActions>
    );
  };

  renderTransactionRow = transaction => {
    const { _id, createdAt, timestamp, product, user } = transaction;

    const { productCategory } = product;
    const { firstName, lastName, email } = user;
    const displayName = firstName && lastName ? `${firstName} ${lastName}` : email;
    const displayType = formatProductDisplayName(product);

    return (
      <tr key={_id}>
        <td>{formatDate(createdAt)}</td>
        <td>{displayName}</td>
        <td>{formatDate(timestamp)}</td>
        <td>{productCategory.name}</td>
        <td>{displayType}</td>
      </tr>
    );
  };

  renderTableHeader = () => {
    return (
      <TableHeader
        items={this.state.tableHead}
        onSort={this.sortTable}
        sortable={this.state.sortedData.length > 1}
      />
    );
  };

  render() {
    const { title } = this.props;
    const transactions = this.state.sortedData;
    return (
      <ContentBlock title={title} renderActions={this.renderHeaderActions}>
        {transactions && transactions.length > 0 ? (
          <Table
            items={transactions.slice(0, 5)}
            renderHeader={this.renderTableHeader}
            renderItem={this.renderTransactionRow}
          />
        ) : (
          <p>Ei vielä myyntejä.</p>
        )}
      </ContentBlock>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const currentUserTeam = getCurrentUserTeam(state);
  //const transactions = currentUser.role === UserRoles.SALESMANAGER ? getTransactionsForCurrentUserChannel(state) : getTransactionsForCurrentUserTeam(state);
  const transactions = getAllTransactions(state);
  return {
    currentUser,
    currentUserTeam,
    transactions
  };
};

const ConnectedLatestTransactionsBlock = connect(mapStateToProps, transactionActions)(
  LatestTransactionsBlock
);

export default ConnectedLatestTransactionsBlock;



// WEBPACK FOOTER //
// ./src/modules/transaction/components/LatestTransactionsBlock.js